import { useState } from "react";
import { post } from "../../utils/api";
import { toast } from "react-toastify";
import InputText from "../../customComponents/InputText";
import ItineraryPicker from "./ItineraryPicker";

const CAROUSEL_TYPES = [
  "FEATURED",
  "NEW_ARRIVALS",
  "UPCOMING_TRIPS",
  "BEST_VALUE",
  "BY_PACKAGE_TYPE",
];

const CarouselModal = ({ editTarget, onClose, onSaved }) => {
  const [title, setTitle] = useState(editTarget?.title || "");
  const [type, setType] = useState(editTarget?.type || "FEATURED");
  const [isActive, setIsActive] = useState(editTarget?.is_active ?? true);
  const displayOrder = editTarget?.display_order ?? 0;
  const [items, setItems] = useState(editTarget?.items || []);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!title.trim()) {
      toast.error("Title is required");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ...(editTarget?.id ? { id: editTarget.id } : {}),
        title: title.trim(),
        type,
        is_active: isActive,
        display_order: Number(displayOrder) || 0,
        ...(type === "FEATURED"
          ? {
              items: items.map((item) => ({
                itinerarydetailsid: item.itinerarydetailsid,
                display_order: item.display_order,
              })),
            }
          : {}),
      };
      await post("/cms/carousel/save", payload);
      toast.success(editTarget ? "Slideshow updated" : "Slideshow created");
      onSaved();
    } catch {
      toast.error("Save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">
            {editTarget ? "Edit Slideshow" : "Add Slideshow"}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl">
            ×
          </button>
        </div>

        <div className="space-y-4">
          <InputText
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter carousel title"
          />

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="w-full h-[40px] border border-gray-300 rounded-md px-3 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              {CAROUSEL_TYPES.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="carousel-active"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              className="w-4 h-4"
            />
            <label htmlFor="carousel-active" className="text-sm text-gray-700">
              Active
            </label>
          </div>

          {type === "FEATURED" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Itineraries
              </label>
              <ItineraryPicker selectedItems={items} onChange={setItems} />
            </div>
          )}
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="px-4 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarouselModal;
